export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40be690758cddd2713f0b0ae6bd54699f3057f0f0f&name=revalidateCommunity!'